"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFailure = void 0;
const Leaf = __importStar(require("leaf-ts"));
const checkoutFailure_html_R_1 = require("./checkoutFailure/checkoutFailure.html.R");
const checkoutFailure_html_R_2 = require("./checkoutFailure/checkoutFailure.theme/business/checkoutFailure.html.R");
const checkoutFailure_html_R_3 = require("./checkoutFailure/checkoutFailure.theme/genesis/checkoutFailure.html.R");
const web_1 = require("@branch-ts/web");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const business_consensus_1 = require("@branch-ts/business-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class CheckoutFailure extends checkoutFailure_html_R_1.R.CheckoutFailure {
    constructor() {
        super();
        this.debug = debug_consensus_1.Debug.instance(this).tag("CheckoutFailure").enable();
        this.present = web_1.PresentMechanism.about(this).lifeCycle(async (about) => {
            await about.declare("present");
            await this.refresh();
            await about.declare("hang");
        });
        this.fault = (0, web_1.FatUIErrorBestPractice)();
    }
    async refresh() {
        const parsed = business_consensus_1.CheckoutReturnUrlContract.parseURL({
            url: window.location.href,
        });
        if (!parsed.ok) {
            this.showInvalidReturn();
            return;
        }
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        const [result, reason, ...errors] = await server.rpcs.VersetUserBillingService.getMyCheckoutReturn({
            subjectURI: parsed.value.subjectURI,
        });
        this.fault.caution.worry({
            message: "Failed to get cancelled Checkout return status",
            reason,
            errors,
        });
        if (!result) {
            return;
        }
        switch (result.checkoutReturn.type) {
            case verset_consensus_1.VersetProtocol.CheckoutReturn.Type.PreCharge:
                this.checkoutReturnType = result.checkoutReturn.type;
                this.VM.title = "Additional-usage checkout cancelled";
                this.VM.message = "No additional usage was granted. You can return to Billing whenever you are ready to try again.";
                this.VM.nextAction = "View Billing";
                return;
            case verset_consensus_1.VersetProtocol.CheckoutReturn.Type.Subscription:
                this.checkoutReturnType = result.checkoutReturn.type;
                this.VM.title = "Subscription checkout cancelled";
                this.VM.message = "Checkout was not completed here. Review your subscription status before trying again; your work remains available.";
                this.VM.nextAction = "Review subscription";
                return;
        }
    }
    showInvalidReturn() {
        this.VM.title = "Checkout not completed";
        this.VM.message = "We could not identify this Checkout return. No payment or account change has been confirmed.";
        this.VM.nextAction = "Return to Verset";
    }
    onClickRetryPaymentBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (this.checkoutReturnType === verset_consensus_1.VersetProtocol.CheckoutReturn.Type.PreCharge) {
            window.location.href = "/dashboard/billing";
            return;
        }
        if (this.checkoutReturnType === verset_consensus_1.VersetProtocol.CheckoutReturn.Type.Subscription) {
            window.location.href = "/dashboard/profile?section=subscription";
            return;
        }
        window.location.href = "/";
    }
    onClickBackToPlansBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        versetUserProfileMechanism_1.VersetUserProfileMechanism.returnToWork();
    }
}
exports.CheckoutFailure = CheckoutFailure;
Leaf.WidgetThemeCenter.about(checkoutFailure_html_R_1.R.CheckoutFailure).add("business", checkoutFailure_html_R_2.R.CheckoutFailure.generator);
Leaf.WidgetThemeCenter.about(checkoutFailure_html_R_1.R.CheckoutFailure).add("genesis", checkoutFailure_html_R_3.R.CheckoutFailure.generator);
